import { useSearchParams } from 'react-router-dom';
import RoundedContainer from '../../common/components/RoundedContainer';
import DashboardLayout from '../../common/layouts/Dashboard';
import { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import { useGetSignedInterviewUrlMutation } from '../../app/services/interview';

//TODO: Delete this page later
export default function TestiFramePage() {
  const [searchParams] = useSearchParams();
  const iframeSrc = searchParams.get('src');
  const [receivedMessage, setReceivedMessage] = useState<any>();
  const [actualIframeSrc, setActualIframeSrc] = useState<string | null>(null);
  const [getSignedInterviewUrl] = useGetSignedInterviewUrlMutation();

  const handleMessage = (event: any) => {
    if (event.data && event.data.type === 'finishedInterview') {
      console.log("Received your message:", event.data);
      setReceivedMessage(JSON.stringify(event.data));
    }
  };

  useEffect(() => {
    const processIframeSrc = async () => {
      if (!iframeSrc) {
        setActualIframeSrc(null);
        return;
      }

      try {
        // Parse the URL to check if it matches the pattern /embed/interview/:providerExternalId/:siteExternalId/:interviewTypeId/:externalId
        const url = new URL(iframeSrc);
        const pathPattern = /^\/embed\/interview\/([^/]+)\/([^/]+)\/([^/]+)\/([^/]+)/;
        const match = url.pathname.match(pathPattern);

        if (match) {
          // Extract path params
          const [, providerExternalId, siteExternalId, interviewTypeId, externalId] = match;

          // Extract query params
          const interviewTimeFrame = url.searchParams.get('interviewTimeFrame') || undefined;
          const interviewType = url.searchParams.get('interviewType') || undefined;
          const interviewExternalId = url.searchParams.get('interviewExternalId') || undefined;
          const visitId = url.searchParams.get('visitId') || undefined;
          const apiKey = url.searchParams.get('apiKey') || undefined;

          // Call API to get signed URL
          const response = await getSignedInterviewUrl({
            providerExternalId: providerExternalId,
            siteExternalId: siteExternalId,
            interviewTypeId: Number(interviewTypeId),
            patientExternalId: externalId,
            interviewExternalId,
            interviewTimeFrame,
            interviewType,
            visitId,
            apiKey,
          }).unwrap();

          setActualIframeSrc(response.url);
        } else {
          // If pattern doesn't match, use the original iframeSrc
          setActualIframeSrc(iframeSrc);
        }
      } catch (error) {
        console.error('Error processing iframe src:', error);
        // On error, fallback to original iframeSrc
        setActualIframeSrc(iframeSrc);
      }
    };

    processIframeSrc();
  }, [iframeSrc, getSignedInterviewUrl]);

  useEffect(() => {
    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  return (
    <DashboardLayout showBreadcrumb={false} sessionExpiration={false}>
      <RoundedContainer
        sx={{
          py: 3,
          '& .MuiBox-root': {
            py: 1,
          },
        }}
      >
        {receivedMessage &&
          <>
            <Typography fontWeight="bold">
              Received message:
            </Typography>
            <Typography>
              {receivedMessage}
            </Typography>
          </>
        }
        {actualIframeSrc ? (
          <iframe
            title={'title'}
            src={actualIframeSrc}
            style={{ height: '100vh', width: '100%' }}
          ></iframe>
        ) : (
          <>
            No iframe src, please add "?src=your_iframe_src" at the end of the url above. For example:
            ".../dashboard/test-iframe?src=https://yourpage"
          </>
        )}
      </RoundedContainer>
    </DashboardLayout>
  );
}
